// libs
import React, { createContext, useReducer } from "react";

// defs
import { IAppState, initialAppState, IPageTitleState, IPageAlertState } from "@store/state/App";

// stores
import { appReducer } from "@store/reducer/App";
import {
    startLoading,
    stopLoading,
    showAlertMessage,
    hideAlertMessage,
    setPageTitle,
    openSideMenu,
    closeSideMenu,
    toggleSideMenu,
    setStage,
} from "@store/actions/App";
import { Stage } from "@helpers/index";

export interface IAppContext extends IAppState {
    startLoading: () => void;
    stopLoading: () => void;
    openSideMenu: () => void;
    closeSideMenu: () => void;
    toggleSideMenu: () => void;
    hideAlertMessage: () => void;
    showAlertMessage: (pageAlert: IPageAlertState) => void;
    setPageTitle: (pageTitle: IPageTitleState) => void;
    setStage: (stage: Stage) => void;
}

export const AppContext = createContext<IAppContext | undefined>(undefined);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const AppProvider = ({ children }) => {
    const [state, dispatch] = useReducer(appReducer, initialAppState);

    return (
        <AppContext.Provider
            value={{
                ...state,
                startLoading: startLoading(dispatch),
                stopLoading: stopLoading(dispatch),
                showAlertMessage: showAlertMessage(dispatch),
                hideAlertMessage: hideAlertMessage(dispatch),
                setPageTitle: setPageTitle(dispatch),
                openSideMenu: openSideMenu(dispatch),
                closeSideMenu: closeSideMenu(dispatch),
                toggleSideMenu: toggleSideMenu(dispatch),
                setStage: setStage(dispatch),
            }}>
            {children}
        </AppContext.Provider>
    );
};
